type Query = Record<string, string | number | boolean | undefined>

function stringify(query: Query): string {
    if (!query) {
        return ''
    }
    return Object.entries(query)
        .sort(([k1], [k2]) => {
            return k1 > k2 ? 1 : k1 < k2 ? -1 : 0
        })
        .map(([key, value]) => {
            if (!key || value === undefined || value === '') {
                return ''
            }
            return `${key}=${encodeURIComponent(value)}`
        })
        .filter((v) => !!v)
        .join('&')
}

export const stringifyUrl = ({url, query}: {url: string; query: Query}): string => {
    const nextQuery = stringify(query)
    const spliter = url.includes('?') ? '&' : '?'

    return `${url}${nextQuery ? `${spliter}${nextQuery}` : ''}`
}

export const getHref = (): string => {
    return window.location.href
}
export const getCurrentPath = (): string => {
    return window.location.origin + window.location.pathname
}
